/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encode & decode URLs`)
};

const es_ue_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificar y decodificar URL`)
};

const de_ue_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URLs kodieren & dekodieren`)
};

const nl_ue_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URLs coderen en decoderen`)
};

const fr_ue_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoder et décoder les URL`)
};

const it_ue_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica e decodifica URL`)
};

const pt_br2_ue_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificar e decodificar URLs`)
};

const pt_ue_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificar e descodificar URLs`)
};

const ja_ue_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URLをエンコード & デコード`)
};

const zh_ue_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编码与解码 URL`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_nav_main_desc", locale)
	if (locale === "en") return en_ue_nav_main_desc(inputs)
	if (locale === "es") return es_ue_nav_main_desc(inputs)
	if (locale === "de") return de_ue_nav_main_desc(inputs)
	if (locale === "nl") return nl_ue_nav_main_desc(inputs)
	if (locale === "fr") return fr_ue_nav_main_desc(inputs)
	if (locale === "it") return it_ue_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_ue_nav_main_desc(inputs)
	if (locale === "pt") return pt_ue_nav_main_desc(inputs)
	if (locale === "ja") return ja_ue_nav_main_desc(inputs)
	return zh_ue_nav_main_desc(inputs)
};